export default "__VITE_ASSET__w6M2VzmT__"